
<script setup lang="ts">
import { ref } from "vue";
import { ChevronDownIcon, ChevronsDownIcon, ListIcon } from 'vue-tabler-icons';
import { format } from 'date-fns';
const props = defineProps({ post: Object });
const linkTo = props.post?.title
    ?.toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '');

</script>
<template>
            <v-col cols="12" md="4" sm="6" >
                <v-card elevation="10" rounded="md" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
                    <v-card-tile>
                        <div class="text-h4 pa-6"> {{ post?.title }}  </div>
                    </v-card-tile>
                    <div class="hover-card overflow-hidden rounded-md lh-10  position-relative rounded-b-0">
                        <!-- <NuxtLink :to="`/jobs/position/${linkTo}`"> -->
                            <img :src="post?.image" alt="image" class="zoom-in w-100" style="opacity: 40%;" />
                        <!-- </NuxtLink> -->
                        <div class="text-subtitle-1 position-absolute top-0 right-0 ma-2">
                            <v-btn variant="plain" density="compact" :ripple="false"
                                class="px-2 py-2 no-effect bg-white text-primary op-1 rounded-circle" min-width="auto"
                                height="auto">
                                <ChevronswqDownIcon color="black" stroke-width="1.5" size="20" />
                            </v-btn>
                        </div>                        
                    </div>
                    <div class="pa-4">
                        <div class="d-flex justify-space-between">
                            <v-chip class="bg-lightdarkgray text-surface rounded-md pa-2 " height="auto" size="small"
                                variant="tonal" >{{ post?.tag }}</v-chip>
                            <p class="text-muted text-h4 text-right">
                               <b>{{ post?.yearly }}</b> USD/year<br/>                               
                               <b>{{ post?.hourly }}</b> USD/hour<br/>
                            </p>
                        </div>
                        <div class="pt-4">
                            <NuxtLink  :to="`/jobs/position/${linkTo}`" class="text-decoration-none">
                                <h4 class="text-h5 font-weight-medium text-dark hover-primary lh-normal">{{ post?.description }}</h4>
                            </NuxtLink>
                        </div>
                        <div class="d-flex align-center mt-10 pt-5">
                            <v-chip class="ma-2" color="primary" variant="outlined">
                                <v-icon icon="mdi-web-box" start></v-icon>
                                Any Country
                            </v-chip>
                            <v-chip class="ma-2" color="primary" variant="outlined">
                                <v-icon icon="mdi-calendar-clock" start></v-icon>
                                Full Time
                            </v-chip>
                            <v-chip class="ma-2" color="primary" variant="outlined">
                                <v-icon icon="mdi-calendar" start></v-icon>
                                Long Term
                            </v-chip>                            
                        </div>
                    </div>
                </v-card>
            </v-col>

</template>